import { PieChart as MuiPieChart, PieChartProps } from '@mui/x-charts';
import React, { useCallback } from 'react';

import { useChartLocale } from 'components/charts/hooks/use-chart-locale';
import { useLocaleSeries } from 'components/charts/hooks/use-locale-series';
import ChartThemeScope from 'components/charts/theme/chart-theme-scope';
import { ChartSurfaceProps } from 'components/charts/types/chart-surface.type';

const PieChart = React.forwardRef<HTMLDivElement, PieChartProps & ChartSurfaceProps>(function PieChart({ dark, ...props }, ref) {
  const { formatValue } = useChartLocale();
  const formatSlice = useCallback((item: { value: number }) => formatValue(item.value), [formatValue]);
  const series = useLocaleSeries(props.series, formatSlice);

  return (
    <ChartThemeScope dark={dark}>
      <MuiPieChart {...props} ref={ref} series={series} />
    </ChartThemeScope>
  );
});

export default PieChart;
